import { apiClient } from '@/shared/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export interface InsurerFormInitData {
  insurer_types: Array<{ id: number; name: string }>;
  insurance_kinds: Array<{ id: number; name: string }>;
  claim_types: Array<{ id: number; name: string }>;
  attachement_documents: Array<{ id: number; name: string }>;
  visit_report_documents: Array<{ id: number; name: string }>;
  visit_detail_reports: Array<{ id: number; name: string }>;
}

export const getInsurerFormInitData = async (
  siteType: string
): Promise<{ data: InsurerFormInitData }> => {
  const response = await apiClient.get<{ data: InsurerFormInitData }>(
    `/admin/${siteType}/insurers/init-form`
  );
  return response.data;
};

export const useInsurerFormInitData = () => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['insurerInitForm', currentSite],
    queryFn: () => getInsurerFormInitData(currentSite),
    select: res => res.data,
  });
};
